<div id="store_details_infos">
    @if(this.showMap){
        <div id="store_maps">
            <google-map  
                height="100%"
                width="100%"
                [options]="this.optionsMap"
                [center]="this.centerMap"
                >
                     <map-marker [position]="this.centerMap" />
            </google-map>
        </div>
    }
    <div id="store_fields">
        <ion-grid>
            <ion-row>
                <ion-col>
                    <marv-field label="{{'STORE_NAME' | translate}}" icon="storefront-outline" [value]="this.store.name"/>
                </ion-col>
                <ion-col>
                    <marv-field label="{{'RETAILER' | translate}}" icon="cart-outline" [value]="this.store.retailer"/>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <marv-field label="{{'ADDRESS' | translate}}" icon="location-outline" [value]="this.store.address"/>
                </ion-col>
                <ion-col>
                    <marv-field label="{{'CITY' | translate}}" icon="business-outline" [value]="this.store.city"/>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <marv-field label="{{'AREA' | translate}}" icon="map-outline" [value]="this.store.customerAreaName || '-'"/>
                </ion-col>
                <ion-col>
                    <marv-field label="{{'SECTOR' | translate}}" icon="trail-sign-outline" [value]="this.store.customerSectorName || '-'"/>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
    
</div>

@if(this.store.showKpis){
    <div id="store_details_kpis">
        <marv-section-title label="{{'KPI_S_STORE' | translate}}" icon="bar-chart-outline"/>          
        @if(this.store.operationsKpis.length === 0){
            <marv-message type="info">{{'MSG_NO_KPI_STORE' | translate}}</marv-message> 
        }
        @else{
            @for(operationKpis of this.store.operationsKpis; track $index){
                <div>
                    <div>
                        <marv-tag [color]="this.missionTypeService.getColor(operationKpis.typeOfMission.code)">{{operationKpis.typeOfMission.name}}</marv-tag>                        
                    </div>
                    <ion-grid class="no_padding">
                        <ion-row class="ion-justify-content-around">  
                            @for(kpi of operationKpis.kpis; track $index){            
                                <ion-col class="no_padding" size="auto">
                                    <app-store-details-kpi [label]="kpi.label" [value]="kpi.value" [color]="kpi.color"/>
                                </ion-col>
                            } 
                        </ion-row>
                    </ion-grid>
                </div>
            }
        }            
    </div>
}

@if(this.store.showOperations){
    <div id="store_details_operations">
        <marv-section-title label="{{'OPERATIONS_STORE' | translate}}" icon="briefcase-outline">
            <form [formGroup]="this.operationsForm">
                <marv-toggle label="{{'ACTIVES_OPERATIONS_ONLY' | translate}}" formName="activesOnly" [noMargin]="true"/>
            </form>
        </marv-section-title>
        @if(this.operationsStore.length === 0){
            <marv-message type="info">{{'MSG_NO_OPERATION_STORE' | translate}}</marv-message> 
        }
        @else{
            @for(operation of this.operationsStore; track operation.id){
                <app-operation-item [operation]="operation" [displayNbMissionsPlanned]="true" [displayBtnAddIntervention]="true" [disabledBtnAddIntervention]="operation.isPlanningClosed" (onAddIntervention)="this.addIntervention($event)"></app-operation-item>
            }
        }
    </div>
}